import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {forwardRef} from "@angular/core";
import {SelectBoxComponent} from "./select-box.component";

export const SelectBoxAccessor: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectBoxComponent),
  multi: true
};
